import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Thanks from "../pages/thanks/page";
import PrivacyPolicy from "../pages/legal/privacidade/page";
import TermsConditions from "../pages/legal/termos/page";
import CookiePolicy from "../pages/legal/cookies/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/obrigado",
    element: <Thanks />,
  },
  {
    path: "/politica-de-privacidade",
    element: <PrivacyPolicy />,
  },
  {
    path: "/termos-e-condicoes",
    element: <TermsConditions />,
  },
  {
    path: "/politica-de-cookies",
    element: <CookiePolicy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
